import React, {Component} from "react"

import { 
  Button,
  GroupBox,
  Window,
  WindowContent,
  WindowHeader,
} from 'react95'

import Draggable from 'react-draggable';

import Icons from './Icons'

import mapImage from "./assets/map.png.webp";

import { t } from './i18n';

class WindowAbout extends Component {
	constructor(props){
		super(props)
		this.state = {
      items: [],
      opacity: 0,
    }
	}
  close() {
    this.props.close()
  }
  componentDidMount () {
    this.props.centerWindows();
    setTimeout(() => {
      this.props.centerWindows();
      this.setState(() => ({opacity: 1}))
    }, 150)
  }

	render(){
    const lang = this.props.lang
    return (
      <Draggable bounds="parent" handle=".draggable-title">
        <Window style={{opacity: this.state.opacity, zIndex: this.props.zIndex}} className='about-window window center-window' onMouseDownCapture={this.props.onFocus}>
          <WindowHeader className={`window-title${this.props.isFocused ? '' : ' inactive'}`}>
            <div className="float-right">
              <Button onClick={this.close.bind(this)}>
                &times;
              </Button>
            </div>
            <div className="draggable-title">
              <span className="Help_16x16_4 window-icon "></span> <span> {t('aboutTitle', lang)}</span>
            </div>
          </WindowHeader>
          <WindowContent>
            <div className="all-16 blue-text">
                <div className="float-left">
                  <i className="fak fa-onlinecreation fa-6x"></i>
                </div> 
                <div className="logo">
                  <span>Online</span>
                  <span>Creation</span>
                </div>
                <div className="float-right">
                  <a href="https://www.linkedin.com/company/onlinecreationme/" target="_blank" rel="noreferrer" className="blue-text"><i className="fa-brands fa-linkedin fa-2x right-16"></i></a>
                  <a href="https://www.facebook.com/onlinecreation.me/" target="_blank" rel="noreferrer" className="blue-text"><i className="fa-brands fa-facebook fa-2x right-16"></i></a>
                </div>
            </div>
            <div className="clearfix all-16">
              &nbsp;
              <p>
                {t('aboutDescription', lang)}
              </p>
            </div>
            <div className="flex-horizontal">
              <GroupBox label={t('aboutLocation', lang)} className="flex-1 all-16">
                <img src={mapImage} alt={t('aboutMapAlt', lang)} />
                <p className="bottom-16">
                  <strong>{t('aboutHQ', lang)}</strong><br />
                  <span className="selectable">OnlineCreation</span><br />
                  <span className="selectable">61 rue du Château d'Eau</span><br/>
                  <span className="selectable">33000</span> <span className="selectable">Bordeaux</span><br />
                  <span className="selectable">France</span>
                </p>
                <p>
                  <strong>{t('aboutCapital', lang)}</strong><br/>
                  <span className="selectable">520 540 188 R.C.S. Bordeaux</span><br/>
                  {t('aboutSiret', lang)}&nbsp;: <span className="selectable">52054018800031</span><br/>
                  {t('aboutTVA', lang)}&nbsp;: <span className="selectable">FR19520540188</span><br/>
                  {t('aboutDirector', lang)}&nbsp;: Raphaël Renaudon<br />
                  {t('aboutHost', lang)}&nbsp;: OVH Cloud
                </p>
              </GroupBox>
              <div className="flex-1">
                <GroupBox label={t('aboutServices', lang)} className="all-16">
                  <ul>
                    <li dangerouslySetInnerHTML={{__html: '• ' + t('aboutServiceWeb', lang)}} />
                    <li dangerouslySetInnerHTML={{__html: '• ' + t('aboutServiceShop', lang)}} />
                    <li dangerouslySetInnerHTML={{__html: '• ' + t('aboutServiceApp', lang)}} />
                    <li dangerouslySetInnerHTML={{__html: '• ' + t('aboutServiceDesign', lang)}} />
                    <li dangerouslySetInnerHTML={{__html: '• ' + t('aboutServiceMaintenance', lang)}} />
                  </ul>
                </GroupBox>
                <GroupBox label={t('aboutTech', lang)} className="all-16">
                  {['wordpress', 'php', 'vuejs', 'html5', 'js', 'css3', 'debianlinux', 'symfony', 'onlc'].map((tech, index) => <Icons icon={tech} index={index} />)}
                </GroupBox>
                <GroupBox label={t('aboutCredits', lang)} className="all-16">
                  <p>
                    {t('aboutCreditsText', lang)} <a href="https://reactjs.org/" target="_blank" rel="noreferrer"><i className="fa-brands fa-react"></i> React</a>, 
                    <a href="https://react95.io/" target="_blank" rel="noreferrer"> React 95</a>, <a href="https://github.com/React95/React95/tree/master/packages/icons" target="_blank" rel="noreferrer">React 95 icons</a> {lang === 'fr' ? 'et' : 'and'} <a href="https://fontawesome.com" target="_blank" rel="noreferrer">FontAwesome 6</a>.
                  </p>
                </GroupBox>
              </div>
            </div>
            <p className='align-right top-16'>
              <Button size='lg' className="buttonLg" onClick={this.close.bind(this)}>{t('aboutClose', lang)}</Button>&nbsp;
              <Button size='lg' className="buttonLg" onClick={this.props.openContact.bind(this)} primary>{t('aboutContactBtn', lang)}</Button>
            </p>
          </WindowContent>
        </Window>
      </Draggable>
    )
  }
}
export default WindowAbout;
